"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _MenuItem = require("./MenuItem.styles");

var _elements = require("../../../styles/elements");

var _SubMenu = _interopRequireDefault(require("../SubMenu/SubMenu"));

var _Dot = _interopRequireDefault(require("../../Dot/Dot"));

var _icons = require("../../../assets/icons");

var _NewLabel = _interopRequireDefault(require("../../NewLabel/NewLabel"));

var _Menu = require("../Menu.provider");

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var STRIP_PROPS = ['isSubMenuItem', 'hasBackground', 'tight', 'hasMoreOptions', 'as', 'highlight'];
var Item = ( /*#__PURE__*/0, _base["default"])('button', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !STRIP_PROPS.includes(prop);
  },
  target: "e10crof30",
  label: "Item"
})(_elements.button.styles.preflight, ";", _MenuItem.styles.base, ";");
var tooltipOffset = [_MenuItem.tooltipOffsetX, 0];

var UnmanagedMenuItem = function UnmanagedMenuItem(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      extraIcon = _ref.extraIcon,
      extraIconType = _ref.extraIconType,
      children = _ref.children,
      subMenu = _ref.subMenu,
      as = _ref.as,
      active = _ref.active,
      open = _ref.open,
      onClick = _ref.onClick,
      value = _ref.value,
      dotColor = _ref.dotColor,
      count = _ref.count,
      isSubMenuItem = _ref.isSubMenuItem,
      hasArrow = _ref.hasArrow,
      subMenuCls = _ref.subMenuCls,
      isNew = _ref.isNew,
      highlight = _ref.highlight,
      alert = _ref.alert,
      propTight = _ref.tight,
      propAnimate = _ref.animate,
      moreOptions = _ref.moreOptions,
      disabled = _ref.disabled,
      hint = _ref.hint,
      title = _ref.title,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "icon", "extraIcon", "extraIconType", "children", "subMenu", "as", "active", "open", "onClick", "value", "dotColor", "count", "isSubMenuItem", "hasArrow", "subMenuCls", "isNew", "highlight", "alert", "tight", "animate", "moreOptions", "disabled", "hint", "title"]);

  var _useContext = (0, _react.useContext)(_Menu.MenuContext),
      ctxTight = _useContext.tight,
      ctxAnimate = _useContext.animate;

  var itemTextRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isItemTextOverflowing = _useState2[0],
      setIsItemTextOverflowing = _useState2[1]; // honour prop tight passed directly if not wrapped around a ctx


  var tight = ctxTight !== undefined ? ctxTight : propTight; // honour prop animate passed directly if not wrapped around a ctx

  var animate = ctxAnimate !== undefined ? ctxAnimate : propAnimate;
  var hasExtra = !!count || alert || !!extraIcon;
  var hasMoreOptions = !!moreOptions;
  var hasTooltip = hint || title && isItemTextOverflowing;
  var handleClick = (0, _react.useCallback)(function (e) {
    onClick(e, value, !subMenu);
  }, [onClick, subMenu, value]);
  (0, _react.useEffect)(function () {
    if (itemTextRef.current) {
      setIsItemTextOverflowing(itemTextRef.current.clientWidth < itemTextRef.current.scrollWidth);
    }
  }, [count, alert]);
  var extra = (0, _jsxRuntime.jsxs)("div", {
    className: "grui ml-auto pl-5 pr-3 flex items-center menu-item-extras",
    css: _MenuItem.styles.extras,
    children: [!!alert && (0, _jsxRuntime.jsx)("span", {
      className: "grui alert",
      css: _MenuItem.styles.alert,
      children: "\xA0"
    }), !!count && (0, _jsxRuntime.jsx)("span", {
      className: "grui count",
      css: [_elements.text.styles.textXs, _elements.text.styles.fontNormal, _MenuItem.styles.count, process.env.NODE_ENV === "production" ? "" : ";label:extra;"],
      children: (0, _jsxRuntime.jsx)("span", {
        children: count
      })
    }), extraIcon && (0, _jsxRuntime.jsx)("span", {
      css: _MenuItem.styles.extraIcon[extraIconType],
      children: extraIcon
    })]
  });
  var item = (0, _jsxRuntime.jsxs)(Item, _objectSpread(_objectSpread({
    as: as,
    className: (0, _clsx["default"])('grui', {
      active: active
    }, className),
    hasBackground: active && !subMenu,
    isSubMenuItem: isSubMenuItem,
    onClick: handleClick,
    tight: tight,
    highlight: highlight,
    hasMoreOptions: hasMoreOptions
  }, otherProps), {}, {
    css: disabled && _MenuItem.styles.disabled,
    children: [icon, dotColor && (0, _jsxRuntime.jsx)(_Dot["default"], {
      color: dotColor,
      size: "small",
      className: "grui mr-4 opacity-100"
    }), (0, _jsxRuntime.jsx)("span", {
      className: "grui truncate",
      ref: itemTextRef,
      children: children
    }), hasArrow && (0, _jsxRuntime.jsx)(_icons.ChevronRight, {
      css: [_MenuItem.styles.arrow, open && _MenuItem.styles.openedArrow, process.env.NODE_ENV === "production" ? "" : ";label:item;"]
    }), isNew && (0, _jsxRuntime.jsx)(_NewLabel["default"], {
      css: [_MenuItem.styles.isNew, process.env.NODE_ENV === "production" ? "" : ";label:item;"],
      className: "grui p-3 ml-2",
      isInfiniteAnimation: true
    }), hasExtra && extra, hasMoreOptions && moreOptions]
  }));
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [hasTooltip && (0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: hint || title,
      strategy: "fixed",
      position: "top",
      offset: tooltipOffset,
      css: _MenuItem.styles.tooltip,
      children: (0, _jsxRuntime.jsx)("div", {
        children: item
      })
    }), !hasTooltip && item, subMenu && (0, _jsxRuntime.jsx)(_SubMenu["default"], {
      open: open,
      css: _MenuItem.styles.submenu,
      className: subMenuCls,
      animate: animate,
      children: subMenu
    })]
  });
};

UnmanagedMenuItem.propTypes = {
  className: _propTypes.string,

  /**
   * Customize element type
   */
  as: _propTypes.elementType,

  /**
   * For the icon in the start
   */
  icon: _propTypes.node,

  /**
   * For the icon in the end
   */
  extraIcon: _propTypes.node,
  extraIconType: (0, _propTypes.oneOf)(['primary', 'warning']),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  subMenu: _propTypes.node,
  active: _propTypes.bool,

  /**
   * Should open the submenu
   */
  open: _propTypes.bool,
  onClick: _propTypes.func,

  /**
   * The unique identifier in the whole menu for the menu item,
   * will pass it through onClick
   */
  value: _propTypes.string,
  dotColor: _propTypes.string,
  count: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.node]),

  /**
   * The submenu item will show normal font-weight
   */
  isSubMenuItem: _propTypes.bool,
  hasArrow: _propTypes.bool,
  subMenuCls: _propTypes.string,

  /**
   * Tight menu item has a smaller left-padding
   */
  tight: _propTypes.bool,

  /**
   * If it's new, show new indicator
   */
  isNew: _propTypes.bool,

  /**
   * if highlight, show different color
   */
  highlight: _propTypes.bool,

  /**
   * if alert, show dot indicator
   */
  alert: _propTypes.bool,
  animate: _propTypes.bool,
  moreOptions: _propTypes.node,
  disabled: _propTypes.bool,
  hint: _propTypes.string,
  // title will be shown as tooltip if the content is overflowed
  // if hint is provided, title will be ignored
  // we can provide hint for the tooltip if we want to force the tooltip to show
  title: _propTypes.string
};
UnmanagedMenuItem.defaultProps = {
  className: undefined,
  as: 'button',
  icon: undefined,
  extraIcon: undefined,
  extraIconType: 'primary',
  children: undefined,
  subMenu: undefined,
  active: false,
  open: false,
  onClick: function onClick() {},
  value: undefined,
  dotColor: undefined,
  count: undefined,
  isSubMenuItem: false,
  hasArrow: false,
  subMenuCls: undefined,
  tight: false,
  animate: true,
  isNew: false,
  highlight: false,
  alert: false,
  moreOptions: undefined,
  disabled: false,
  hint: undefined,
  title: undefined
};
var _default = UnmanagedMenuItem;
exports["default"] = _default;
//# sourceMappingURL=UnmanagedMenuItem.js.map